import { Box, Divider, Grid, Tab, Tabs, Typography, useMediaQuery } from '@mui/material';
import { PageTitle } from '../../layoutPages/components/PageTitle';
import { HaveImage, Paragraph } from '../../layoutPages/containers/Paragraphs/Paragraph';
import { TabDefaultSetting } from '../../layoutPages/defaultSetting';
import { DottedList } from '../../layoutPages/containers/DottedList';
import { MainCard } from '../../layoutPages/components/MainCard';
import { CourseTab } from '../CourseTarget/menuTab';
import { enrollmentMenuData } from '../../data/enrollmentMenuData';

export function Pagefeatures() {

    const isPc = useMediaQuery('(min-width:600px)');

    let dottedListData = [
        "學校著力培養學生閱讀能力，推動每日閱讀習慣，促進全人學習。",
        "家長可選擇讓子女以普通話學習中國語文。",
        "校本英語課程涵蓋 Phonics、Sight Word 及 PLPR 閱讀計劃，並聘請外籍教師提升英語能力。",
        "師資專業且有愛心：100% 持教育文憑，95.5% 擁有大學學位，27% 已獲或正修讀碩士學位。經教統局外評獲七項「優異」（最高等級），包括策劃與行政、專業領導、學校文化、教職員管理、課程策劃與管理、與家長及外間聯繫及自我評估。",
        "以關懷文化推動訓導與輔導並行，促進學生全面發展；開校以來，從無學生被記缺點或過失。",
        "以全語文策略推動自由寫作，鼓勵多寫多表達。",
        "資訊科技既獨立成科，亦與各科融合，培養學生運用科技作為終身學習工具的能力。",
        "千禧校舍設備完善，支援優質教育。"
    ];

    return (
        <Grid container direction="row" justifyContent="center" alignItems="top" spacing={2}>
            <Grid item xs={11} sm={10} >

                <br></br>
                <CourseTab data={enrollmentMenuData} />

                <PageTitle title='本校特色 | 入學資訊' size='h3' sx={{ m: 5 }} />

                <Paragraph
                    instantAppear
                    data={[
                        <DottedList data={dottedListData} />
                    ]}
                />

            </Grid>
        </Grid>
    )
}
